






































































import Vue from "vue";
import Component from "vue-class-component";
import * as CONSTANTS from "../../common/constants";

@Component({})
export default class Sidebar extends Vue {
  name: "Sidebar";

  get ROUTE_NAME() {
    return CONSTANTS.ROUTE_NAME;
  }
}
